// npm i sparqljs
import { Parser } from "sparqljs";

const parser = new Parser({ skipValidation: true });

export function collectGraphsFromSPARQL(sparql) {
  const ast = parser.parse(sparql);
  return collectGraphs(ast);
};

function collectGraphs(ast) {
  const graphs = new Set();

  // SELECT/CONSTRUCT/DESCRIBE/ASK: FROM / FROM NAMED
  if (ast.from) {
    (ast.from.default || []).forEach(g => graphs.add(g.value ?? g));
    (ast.from.named || []).forEach(g => graphs.add(g.value ?? g));
  }

  // UPDATE: USING / USING NAMED
  if (ast.using) {
    (ast.using.default || []).forEach(g => graphs.add(g.value ?? g));
    (ast.using.named || []).forEach(g => graphs.add(g.value ?? g));
  }

  // UPDATE form can be an array of operations
  const ops = Array.isArray(ast.updates) ? ast.updates : [];
  for (const op of ops) {
    if (op.using) {
      (op.using.default || []).forEach(g => graphs.add(g.value ?? g));
      (op.using.named || []).forEach(g => graphs.add(g.value ?? g));
    }
    walkPatterns(op.where, graphs);
    walkUpdateTemplate(op.insert, graphs);
    walkUpdateTemplate(op.delete, graphs);
  }

  // Query form: walk WHERE patterns
  walkPatterns(ast.where, graphs);

  return [...graphs];
}

function walkUpdateTemplate(template, graphs) {
  // INSERT/DELETE template обычно массив "quads"/"triples" или паттернов
  if (!template) return;
  // В sparqljs для GRAPH в шаблоне обычно встречается pattern type 'graph'
  if (Array.isArray(template)) walkPatterns(template, graphs);
  else if (template.where) walkPatterns(template.where, graphs);
}

function walkPatterns(patterns, graphs) {
  if (!patterns) return;
  const arr = Array.isArray(patterns) ? patterns : [patterns];

  for (const p of arr) {
    if (!p) continue;

    // GRAPH <iri> { ... }
    if (p.type === "graph" && p.name) {
      graphs.add(p.name.value ?? p.name); // name может быть term или строка
      walkPatterns(p.patterns, graphs);
      continue;
    }

    // вложенные группы
    if (p.type === "group" || p.type === "optional" || p.type === "minus") {
      walkPatterns(p.patterns, graphs);
      continue;
    }

    // UNION
    if (p.type === "union" && Array.isArray(p.patterns)) {
      for (const branch of p.patterns) walkPatterns(branch, graphs);
      continue;
    }

    // subquery
    if (p.type === "query") {
      // подзапрос тоже может иметь FROM/WHERE
      const sub = p;
      if (sub.from) {
        (sub.from.default || []).forEach(g => graphs.add(g.value ?? g));
        (sub.from.named || []).forEach(g => graphs.add(g.value ?? g));
      }
      walkPatterns(sub.where, graphs);
      continue;
    }
  }
}